function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M23.911,15.97,21.332,6.31A2.452,2.452,0,0,0,20,4.72V3.5A2.5,2.5,0,0,0,17.5,1H2.5A2.5,2.5,0,0,0,0,3.5v10A2.5,2.5,0,0,0,2.5,16h.72L4.6,21.15a2.479,2.479,0,0,0,3.06,1.76l14.491-3.88A2.5,2.5,0,0,0,23.911,15.97ZM1.332,3.5A1.164,1.164,0,0,1,2.5,2.33h15a1.165,1.165,0,0,1,1.17,1.17V4.64H1.332Zm0,2.47H18.671V7.91H1.332ZM2.5,14.67A1.171,1.171,0,0,1,1.332,13.5V9.24H18.671V13.5a1.171,1.171,0,0,1-1.17,1.17ZM22.512,17.2a1.161,1.161,0,0,1-.711.55L7.311,21.63a1.026,1.026,0,0,1-.3.04,1.175,1.175,0,0,1-1.13-.87L4.592,16H17.5A2.5,2.5,0,0,0,20,13.5V6.55a.407.407,0,0,1,.04.11l2.591,9.65A1.155,1.155,0,0,1,22.512,17.2Zm-7.177-3.535A.665.665,0,0,1,14.67,13V11.333a.665.665,0,0,1,.665-.665H17A.665.665,0,1,1,17,12H16v1A.665.665,0,0,1,15.335,13.665Z",
  transform: "translate(-0.001 -1)"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.997,
    height: 22,
    viewBox: "0 0 23.997 22"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/credit_card.3702077d.svg";
export { SvgComponent as ReactComponent };